import { apiSauceInstance } from 'src/services/api'

export function generateRelatorio<T>(url: string, data: T) {
  return apiSauceInstance.post<unknown, ApiErrorResponse>(url, data)
}
